<p>
  role-details works!
</p>
